export interface StatusBreakdown {
  inTransit: number;
  discharged: number;
  inDelivery: number;
  completed: number;
}

export interface ActiveContainersStats {
  total: number;
  breakdown: StatusBreakdown;
}

export interface PortOriginStat {
  port: string;
  count: number;
}

export interface InTransitStats {
  total: number;
  vesselsCount: number;
  byOrigin: PortOriginStat[];
}

export interface ArrivingSoonStats {
  total: number;
  /** 14 elemente, index 0 = azi, index 13 = +13 zile */
  byDay: number[];
}

export interface DischargedStats {
  total: number;
  mostRecentDays: number | null;
}

export interface TransitCostsStats {
  total: number;
  currency: string;
  /** 6 elemente, index 0 = luna curentă */
  byMonth: number[];
}

export interface ExtendedStatistics {
  active: ActiveContainersStats;
  inTransit: InTransitStats;
  arrivingSoon: ArrivingSoonStats;
  discharged: DischargedStats;
  transitCosts: TransitCostsStats;
}

export const EMPTY_EXTENDED_STATISTICS: ExtendedStatistics = {
  active: { total: 0, breakdown: { inTransit: 0, discharged: 0, inDelivery: 0, completed: 0 } },
  inTransit: { total: 0, vesselsCount: 0, byOrigin: [] },
  arrivingSoon: { total: 0, byDay: new Array(14).fill(0) },
  discharged: { total: 0, mostRecentDays: null },
  transitCosts: { total: 0, currency: 'USD', byMonth: new Array(6).fill(0) },
};
